import React, { useEffect } from "react";
import confetti from "canvas-confetti";
import { PartyPopper, X, Sparkles, MessageCircle, Banknote, Gamepad2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { fmt } from "../lib/format";

export const WinCelebration = ({ amount, count, games = [], onClose, onShare }) => {
  const navigate = useNavigate();
  const ta = (localStorage.getItem("rl_lang") || "ta") === "ta";
  const withdraw = () => { onClose(); navigate(`/withdraw?amount=${Math.floor(amount || 0)}`); };
  const play = () => { onClose(); navigate("/"); };
  useEffect(() => {
    const colors = ["#FFC107", "#FFE082", "#2563EB", "#10B981", "#ffffff"];
    const fire = (particleRatio, opts) =>
      confetti({ origin: { y: 0.55 }, colors, ...opts, particleCount: Math.floor(260 * particleRatio) });
    fire(0.25, { spread: 26, startVelocity: 58 });
    fire(0.2, { spread: 60 });
    fire(0.35, { spread: 100, decay: 0.91, scalar: 0.9 });
    fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 });
    fire(0.1, { spread: 120, startVelocity: 45 });
    const shots = [700, 1400].map((d) =>
      setTimeout(() => {
        confetti({ particleCount: 60, angle: 60, spread: 70, origin: { x: 0 }, colors });
        confetti({ particleCount: 60, angle: 120, spread: 70, origin: { x: 1 }, colors });
      }, d),
    );
    return () => shots.forEach(clearTimeout);
  }, []);

  return (
    <div className="fixed inset-0 z-[3400] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" data-testid="win-celebration" onClick={onClose}>
      <div className="w-full max-w-xs rl-card p-6 text-center relative rl-fade-up overflow-hidden" onClick={(e) => e.stopPropagation()} style={{ background: "linear-gradient(160deg,#0B1226,#16264A)" }}>
        <div className="rl-win-glow" />
        <button onClick={onClose} className="absolute top-3 right-3 text-white/50 z-10" data-testid="win-celebration-close"><X className="w-5 h-5" /></button>
        <div className="relative z-10">
          <div className="w-20 h-20 rounded-3xl rl-gold-bg flex items-center justify-center mx-auto rl-milestone-pop" style={{ background: "linear-gradient(150deg,#FFE082,#FFC107,#B8860B)", color: "#1A1200" }}>
            <PartyPopper className="w-10 h-10" strokeWidth={2.2} />
          </div>
          <h2 className="font-display font-black text-2xl mt-4 rl-gold-text">You Won!</h2>
          <p className="text-sm text-white/60 mt-1">
            {count > 1 ? `${count} winning bets` : "Congratulations on your win"}
            {games.length > 0 && <> · <span className="text-white/80">{games.slice(0, 2).join(", ")}{games.length > 2 ? "…" : ""}</span></>}
          </p>
          <div className="mt-4 inline-flex items-center gap-2 bg-emerald-500 text-white font-black text-2xl px-6 py-2.5 rounded-full" data-testid="win-celebration-amount">
            <Sparkles className="w-5 h-5" />{fmt(amount)}
          </div>
          <div className="mt-4 rounded-2xl bg-white/10 border border-white/15 p-3 text-left" data-testid="win-payout-choice">
            <div className="text-xs font-black text-amber-200">{ta ? `உங்க winning ₹${fmt(amount).replace("₹", "")} — என்ன பண்ணலாம்?` : `Your winnings ${fmt(amount)} — what next?`}</div>
            <div className="text-[11px] text-white/70 mt-0.5">{ta ? "பணம் வேணும்னா GPay number / UPI ID / QR / bank account கொடுங்க — உடனே அனுப்புறோம். இல்லன்னா அப்படியே விளையாடலாம்." : "Want the money? Give your GPay number / UPI ID / QR / bank account and we pay fast. Or keep it and play on."}</div>
            <div className="grid grid-cols-2 gap-2 mt-2.5">
              <button onClick={withdraw} className="bg-emerald-500 text-white font-black py-2.5 rounded-xl text-xs flex items-center justify-center gap-1.5 active:scale-[0.98]" data-testid="win-choice-withdraw"><Banknote className="w-4 h-4" />{ta ? "பணம் வாங்கணும்" : "Withdraw"}</button>
              <button onClick={play} className="bg-white/15 text-white font-black py-2.5 rounded-xl text-xs flex items-center justify-center gap-1.5 active:scale-[0.98]" data-testid="win-choice-play"><Gamepad2 className="w-4 h-4" />{ta ? "விளையாடுறேன்" : "Keep playing"}</button>
            </div>
          </div>
          {onShare && <button onClick={onShare} className="mt-5 w-full bg-[#25D366] text-white font-black py-3 rounded-2xl flex items-center justify-center gap-2" data-testid="win-celebration-share"><MessageCircle className="w-5 h-5" />Share my win on WhatsApp Status</button>}
          <button onClick={onClose} className={`${onShare ? "mt-2" : "mt-5"} w-full rl-gold-bg font-bold py-3 rounded-2xl`} style={{ background: "linear-gradient(135deg,#FFC107,#FFE082)", color: "#1A1200" }} data-testid="win-celebration-ok">Collect & Continue</button>
        </div>
      </div>
    </div>
  );
};
